export const colors = ["rgb(85, 183, 126)", "#f8c348", "#ff7f0b", "#d63838"];
